(function () {
  // Config dal theme.liquid
  var CFG = (window.VMI_ACCOUNT_URLS || {});
  var LOGIN_URL = CFG.login || '/account/login';
  var REGISTER_URL = CFG.register || '/account/register';
  var KEY = 'vmi_return_to';

  function qp(name) {
    var m = location.search.match(new RegExp('(?:[?&])' + name + '=([^&]+)'));
    return m ? decodeURIComponent(m[1]) : null;
  }
  function safePath(u) {
    if (!u) return null;
    try {
      var x = new URL(u, location.origin);
      if (x.origin === location.origin) return (x.pathname + x.search + x.hash) || '/';
      return null;
    } catch (e) {
      return (typeof u === 'string' && u.charAt(0) === '/') ? u : null;
    }
  }
  function isAccountPath(p) {
    return /^\/account(\/|$)/.test(p || '');
  }
  function fromReferrer() {
    try {
      var r = new URL(document.referrer);
      if (r.origin !== location.origin) return null;
      var p = r.pathname + r.search + r.hash;
      return isAccountPath(p) ? null : p;
    } catch (e) { return null; }
  }
  function ensureHiddenInput(form, value) {
    if (!form) return;
    var hid = form.querySelector('input[name="return_to"]');
    if (!hid) {
      hid = document.createElement('input');
      hid.type = 'hidden';
      hid.name = 'return_to';
      form.appendChild(hid);
    }
    hid.value = value;
  }

  // 1) Se c'è ?return_to= valido, salvalo stabile in sessione
  var q = qp('return_to');
  var qSafe = safePath(q);
  if (qSafe && !isAccountPath(qSafe)) {
    sessionStorage.setItem(KEY, qSafe);
  }

  // 2) Recupera l’URL di ritorno “migliore”
  var back = sessionStorage.getItem(KEY) || fromReferrer() || '/';

  // 3) Sanitize: mai puntare ad /account/* né restare sulla stessa pagina
  if (!back || isAccountPath(back) || back === location.pathname) back = '/';

  // 4) Scrivi l'hidden nei form
  // Login
  var loginForm = document.getElementById('customer_login') ||
                  document.querySelector('form[action*="/account/login"]') ||
                  document.querySelector('form#customer_login');
  ensureHiddenInput(loginForm, back);

  // Register (nel tuo tema ha class="simple-form")
  var registerForm = document.querySelector('form.simple-form') ||
                     document.querySelector('form[action*="/account"]');
  ensureHiddenInput(registerForm, back);

  // 5) Aggiorna i link di switch mantenendo il back
  var regLink = document.getElementById('register-link') ||
                document.querySelector('a[href*="/account/register"]');
  if (regLink) regLink.href = REGISTER_URL + '?return_to=' + encodeURIComponent(back);

  var loginLink = document.getElementById('login-link') ||
                  document.querySelector('a[href*="/account/login"]');
  if (loginLink) loginLink.href = LOGIN_URL + '?return_to=' + encodeURIComponent(back);

  // 6) GUARD post-login:
  // Se sei già loggato ma ti trovi su /account/login o /account/register,
  // fai redirect immediato alla vera destinazione (sessionStorage o query).
  if (document.body && document.body.classList.contains('customer-logged-in')) {
    var dest = sessionStorage.getItem(KEY) || qp('return_to') || '/';
    dest = safePath(dest);
    if (!dest || isAccountPath(dest)) dest = '/';

    if (location.pathname === '/account/login' || location.pathname === '/account/register') {
      // replace per non sporcare la history con la pagina account
      location.replace(dest);
    }
  }

  // (Opzionale) se vuoi propagare return_to anche sul nuovo login Shopify (NCA), sblocca questo:
  // document.querySelectorAll('a[href*="shopify.com/authentication"]').forEach(function(a){
  //   try { var u = new URL(a.href); u.searchParams.set('return_to', back); a.href = u.toString(); } catch(e){}
  // });
})();